export default __webpack_public_path__ + "static/media/miguel-lopes-30.ff49b996.jpg";